import { TSprite } from "../../models/objects/sprite";
import { getImagePath } from "../../utils/format/valueFormat";

export function buildSpriteThumbnails(
  sprites: TSprite[],
  timeoutMs = 3000,
): Promise<Record<string, string>> {
  return Promise.all(
    sprites
      .filter((sprite) => sprite.image_url)
      .map(
        (sprite) =>
          new Promise<[string, string]>((resolve) => {
            const url = getImagePath(sprite.image_url);
            const img = new Image();
            img.crossOrigin = "anonymous";
            let settled = false;
            const fallback = () => {
              if (!settled) {
                settled = true;
                console.warn(
                  `Impossible de créer la miniature de ${sprite.name}.`,
                );
                resolve([sprite.name, url]);
              }
            };
            const timer = window.setTimeout(fallback, timeoutMs);
            img.onload = () => {
              if (settled) return;
              const animation = sprite.animations?.[0];
              const width = animation?.frame_width || 64;
              const height = animation?.frame_height || 64;
              try {
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                canvas
                  .getContext("2d")
                  ?.drawImage(
                    img,
                    animation?.offset_x ?? 0,
                    animation?.offset_y ?? 0,
                    width,
                    height,
                    0,
                    0,
                    width,
                    height,
                  );
                const data = canvas.toDataURL("image/png");
                settled = true;
                window.clearTimeout(timer);
                resolve([sprite.name, data]);
              } catch {
                fallback();
              }
            };
            img.onerror = fallback;
            img.src = url;
          }),
      ),
  ).then((entries) => Object.fromEntries(entries));
}
